import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ModalManager from '../../../../components/modal/ModalManager';
import {NotificationManager} from '../../../../components/common/react-notifications';
import Rbac from '../../../../components/Rbac';
import Api from '../../../../services/Api';
import ReactTable from 'react-table';
import {filter} from 'lodash';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      admins: [],
      loading: true,
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/adminUsers', null, {
        params: {
          limit: 700,
        }
      });
      this.setState({
        admins: data.rows,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  deleteAdmin = async id => {
    const {t} = this.props;
    try {
      await Api.invoke('DELETE', '/admin-ui/admin-users', {id});
      NotificationManager.success(t('Admin deleted successfully'), t('Message'));
      this.setState({
        admins: filter(this.state.admins, obj => obj.id !== id),
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onPressCreate = () => {
    this.props.history.push('/dashboard/settings/admins/create');
  };

  onPressDelete = id => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Delete'),
      body: t('Are you sure you want to delete this admin ?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.deleteAdmin(id);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  getColumns = t => [
    {
      Header: t('Username'),
      accessor: 'username',
    },
    {
      Header: t('First Name'),
      accessor: 'firstName',
    },
    {
      Header: t('Last Name'),
      accessor: 'lastName',
    },
    {
      Header: t('Email'),
      accessor: 'email',
      width: 250,
    },
    {
      Header: t('Mobile Number'),
      accessor: 'phoneNumber',
    },
    {
      Header: t('Role'),
      accessor: 'role',
    },
    {
      Header: t('Actions'),
      width: 100,
      Cell: props => <div>
        <Rbac permission='delete_admin-users'>
          <i
            className="simple-icon-trash delete-icon mx-3 cursor-pointer"
            onClick={() => {this.onPressDelete(props.original.id);}}
          />
        </Rbac>
        <Rbac permission='update_admin-users'>
          <Link to={{
            pathname: '/dashboard/settings/admins/update',
            state: {
              admin: props.original,
            },
          }}>
            <i className="simple-icon-pencil edit-icon mx-3 cursor-pointer"/>
          </Link>
        </Rbac>
      </div>,
      show: Rbac.hasPermission('update_admin-users') || Rbac.hasPermission('delete_admin-users'),
    },
  ];

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={this.props.match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary d-flex flex-row justify-content-between align-items-center">
                  {t('Admins List')}
                  <Rbac permission='create_admin-users'>
                    <Button onClick={this.onPressCreate}>
                      <i className="simple-icon-plus add-reply-icon"/>
                      <span className="mx-1">{t('Add')}</span>
                    </Button>
                  </Rbac>
                </CardTitle>
                <ReactTable
                  manual
                  className="-highlight"
                  data={this.state.admins}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  showPagination={false}
                  columns={this.getColumns(t)}
                  pageSize={this.state.admins.length || 5}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
